import React, { Component } from 'react'
import { connect } from 'react-redux'

// Utils
import { translation } from '../../../utils/helpers'
// import { hasSubscriptionPermission } from '../../../utils/auth'

// Actions
import { getBookingPortalInformation, saveBookingPortalInformation } from '../../../actions/settings'

// Elements
import Row from '../../../shared/elements/row'
import Col from '../../../shared/elements/col'
import Panel from '../../../shared/elements/panel'
import Switch from '../../../shared/elements/switch'
import Text from '../../../shared/elements/text'
import TextArea from '../../../shared/elements/textarea'
import Divider from '../../../shared/elements/divider'

import './bookingportal.scss'
// import LabelWrapper from '../../../shared/elements/labelWrapper'

class BookingPortal extends Component {
  constructor (props) {
    super(props)
    this.state = {
      bookingPortal: {
        Enabled: false,
        EmbedSnippet: '',
        BookingPortalCustomerName: '',
        PrivacyPolicyUrl: '',
        BookingPortalRedirectUrl: '',
        BookingPortalLastStepSubmitText: '',
        OfferCarRentalAlts: false,
        BookingPortalWelcomeMessageText: ''
      }
    }

    this.getBookingPortalInformation = this.getBookingPortalInformation.bind(this)
    this.saveBookingPortalInformation = this.saveBookingPortalInformation.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onBlur = this.onBlur.bind(this)
  }

  componentDidMount () {
    this.getBookingPortalInformation()
  }

  getBookingPortalInformation () {
    this.props.getBookingPortalInformation().then((res) => {
      this.setState({
        bookingPortal: res.data
      })
    }, () => {
      // Err loading
    })
  }

  saveBookingPortalInformation () {
    this.props.saveBookingPortalInformation(this.state.bookingPortal).then((res) => {
      this.setState({
        bookingPortal: res.data
      })
      // window.toastr.success(translation('16725'), translation('13424'))
    }, () => {
      // Err saving
      window.toastr.error(translation('16726'), translation('216'))
    })
  }

  onChange (e) {
    e.persist()
    let value = e.target.value
    if (e.target.type === 'checkbox') {
      value = e.target.checked
    }
    this.setState({
      bookingPortal: {
        ...this.state.bookingPortal,
        [e.target.name]: value
      }
    }, () => {
      if (e.target.type === 'checkbox') {
        this.onBlur(e)
      }
    })
  }

  onBlur (e) {
    this.saveBookingPortalInformation()
  }

  renderEmbedInfo () {
    return (
      <Col span={3}>
        <Panel title={16744}>
          <p>{translation(16735)}</p>
          <Divider noLine />
          <p>{translation(16736)}</p>
          <Divider noLine />
          <div className='snippet'>
            <TextArea labelText={16737} disabled value={this.state.bookingPortal.EmbedSnippet} />
          </div>
        </Panel>
      </Col>
    )
  }

  renderLastStepSubmitText () {
    return (
      <Col span={5}>
        <Panel title={16739}>
          <div className='submit-text'>
            <TextArea name='BookingPortalLastStepSubmitText' labelText={translation(16738)} value={this.state.bookingPortal.BookingPortalLastStepSubmitText || ''} onChange={this.onChange} onBlur={this.onBlur} />
          </div>
        </Panel>
      </Col>
    )
  }

  renderWelcomeMessageText () {
    return (
      <Col span={5}>
        <Panel title={18153}>
          <div className='submit-text'>
            <TextArea name='BookingPortalWelcomeMessageText' labelText={translation(18315)} value={this.state.bookingPortal.BookingPortalWelcomeMessageText || ''} onChange={this.onChange} onBlur={this.onBlur} />
          </div>
        </Panel>
      </Col>
    )
  }

  renderPrivacyPolicyInfo () {
    return (
      <Col span={5}>
        <Panel title={16653}>
          <Text name='PrivacyPolicyUrl' labelText={translation(16740)} value={this.state.bookingPortal.PrivacyPolicyUrl || ''} placeholder={'http://'} onChange={this.onChange} onBlur={this.onBlur} />
        </Panel>
      </Col>
    )
  }

  renderBookingRequestRedirectUrl () {
    return (
      <Col span={5}>
        <Panel title={18457}>
          <Text name='BookingPortalRedirectUrl' labelText={translation(18458)} value={this.state.bookingPortal.BookingPortalRedirectUrl || ''} placeholder={'http://'} onChange={this.onChange} onBlur={this.onBlur} />
        </Panel>
      </Col>
    )
  }

  renderCustomerInfo () {
    return (
      <Panel title={16741}>
        <Text labelText={16742} value={this.state.bookingPortal.BookingPortalCustomerName || ''} disabled />
        <Text labelText={16743} value={this.state.bookingPortal.BookingPortalContactName || ''} disabled />
      </Panel>
    )
  }

  renderCarRentalAltsInfo () {
    return (
      <Col span={5}>
        <Panel title={16751} helpText={16757}>
          <Switch name='OfferCarRentalAlts' checked={this.state.bookingPortal.OfferCarRentalAlts} onChange={this.onChange} labelText={16752} />
        </Panel>
      </Col>
    )
  }

  render () {
    return (
      <div className='bookingportal__settings'>
        <Row>
          <div className='clearfix colwrapper'>
            <Col>
              <Panel title={16681}>
                <Switch name='Enabled' onChange={this.onChange} checked={this.state.bookingPortal.Enabled} labelText={16682} />
              </Panel>
              {this.state.bookingPortal.Enabled && this.renderCustomerInfo()}
            </Col>
            {this.state.bookingPortal.Enabled && this.renderEmbedInfo()}
          </div>
          {this.state.bookingPortal.Enabled && this.renderLastStepSubmitText()}
          {this.state.bookingPortal.Enabled && this.renderWelcomeMessageText()}
          {this.state.bookingPortal.Enabled && this.renderPrivacyPolicyInfo()}
          {this.state.bookingPortal.Enabled && this.renderBookingRequestRedirectUrl()}
          {this.state.bookingPortal.Enabled && this.renderCarRentalAltsInfo()}
        </Row>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  getBookingPortalInformation,
  saveBookingPortalInformation
})(BookingPortal)



// WEBPACK FOOTER //
// ./src/app/pages/Settings/BookingPortal/index.js